import { fromJS } from "immutable";
import { useState } from "react";
import { useSelector } from "react-redux";
import { formatDistanceToNow, isValid } from "date-fns";

const MessageDetail = ({ eventData }) => {
  const members = useSelector((state: any) => state.projectReducer.getIn(["project", "members"]));
  const accountId = useSelector((state: any) =>
    state.activityReducer.getIn(["activity", "event", "person"])
  );
  const createdAt = useSelector((state: any) =>
    state.activityReducer.getIn(["activity", "event", "createdAt"])
  );

  const [open, setOpen] = useState(true);

  const user =
    members.find((member) => member.get("accountId") == accountId) ||
    fromJS({ accountId, displayName: accountId });

  const getPlainText = (html) => {
    if (!html) return "";
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  return (
    <div className="w-full space-y-2">
      <div>
        <button
          onClick={() => setOpen(!open)}
          className="w-full flex items-center gap-4 hover:bg-gray-50 p-2"
        >
          {user.get("avatarUrl") ? (
            <img
              src={user.get("avatarUrl")}
              alt={user.get("displayName")}
              className="relative h-8 w-8 flex-none rounded-full bg-gray-50"
              onError={(e) => (e.currentTarget.style.display = "none")}
            />
          ) : (
            <span className="relative h-8 w-8 flex-none rounded-full bg-gray-200 text-xs flex items-center justify-center font-semibold">
              {(user.get("displayName") || "?").toString().slice(0, 1).toUpperCase()}
            </span>
          )}
          <div className="flex items-center gap-2">
            <span className="font-semibold text-gray-900">{user.get("displayName")}</span>
            <span className="text-sm text-gray-500">
              {createdAt && isValid(new Date(createdAt * 1000))
                ? `${formatDistanceToNow(new Date(createdAt * 1000))} ago`
                : ""}
            </span>
          </div>
        </button>
      </div>
      <div
        className={`max-w-[1000px] ml-6 px-4 border-l-2 border-gray-200 overflow-hidden transition-all duration-300 ${
          open ? "max-h-full" : "max-h-max"
        }`}
      >
        {open ? (
          <div
            className="text-sm text-gray-700 prose prose-sm max-w-none whitespace-pre-wrap break-words"
            dangerouslySetInnerHTML={{
              __html: (eventData.description || "<div>No data found</div>").replace(/&nbsp;/g, " "),
            }}
          />
        ) : (
          <div className="truncate">{getPlainText(eventData.description).substring(0, 300)}</div>
        )}
      </div>
      <div className="ml-6 text-sm text-gray-500">
        {`to: ${(eventData.attendees || []).join("; ")}`}
      </div>
    </div>
  );
};

export default MessageDetail;
